export default function adaptSSN(socialSecurityNumber: string): string {
    if (socialSecurityNumber.indexOf('-') == -1 && socialSecurityNumber.length == 12) {
        socialSecurityNumber = socialSecurityNumber.substring(0, 8) + '-' + socialSecurityNumber.substr(8)
    }

    return socialSecurityNumber;
} 